/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import chunk from "lodash/chunk"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"
import { Flex } from "@theme-ui/components"
import { renderLineBreak } from "../helpers"
import Column from "./column"
import Container from "./container"
import PageLink from "./page-link"
import Row from "./row"
import Text from "./text"
import RichText from "../components/rich-text"
import InfoIconLink from "../components/info-icon-link"
import CTA from "../components/cta"

const numberWithCommas = x => {
  // if(x && !isNaN(x))
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  // else
  // return x
}

const SpecificationsDetails = ({
  awards,
  description,
  inTheNews,
  richText,
  tableContent,
  locationUrl,
  ...restProps
}) => (
  <div {...restProps}>
    <Container>
      {description && (
        <Row customStyle={{ mb: theme => theme.spacing.vertical.sm }}>
          <Column>
            {documentToReactComponents(description, {
              renderNode: {
                [BLOCKS.HEADING_3]: (node, children) => (
                  <Text type="h3">{children}</Text>
                ),
                [BLOCKS.PARAGRAPH]: () => null,
                [BLOCKS.OL_LIST]: () => null,
                [BLOCKS.UL_LIST]: () => null,
              },
              renderText: text => renderLineBreak(text),
            })}
          </Column>
        </Row>
      )}
      <Row customStyle={{ justifyContent: "space-between" }}>
        <Column size={[12, 12, 4]}>
          {description &&
            documentToReactComponents(description, {
              renderNode: {
                [BLOCKS.HEADING_3]: () => null,
                [BLOCKS.PARAGRAPH]: (node, children) => (
                  <Text customStyle={{ mb: theme => theme.spacing.horizontal }}>
                    {children}
                  </Text>
                ),
                [BLOCKS.EMBEDDED_ASSET]: node => (
                  <img
                    sx={{}}
                    src={node.data.target.fields.file["en-US"].url}
                    alt=""
                  />
                ),
                "asset-hyperlink": node => (
                  <a
                    href={node.data.target.fields.file["en-US"].url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {node.content[0].value}
                  </a>
                ),
                [BLOCKS.UL_LIST]: (node, children) => (
                  <ul
                    sx={{
                      mb: 0,
                      "p+&": {
                        mt: -20,
                      },
                    }}
                  >
                    {children}
                  </ul>
                ),
                [BLOCKS.LIST_ITEM]: (node, children) => (
                  <li
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      lineHeight: 1,
                      mb: 0,
                      position: "relative",
                      ":last-child": { mb: 2 },
                      "::before": {
                        content: '"\\2022"',
                        fontSize: 1,
                        position: "absolute",
                        top: "5px",
                        left: "-12px",
                      },
                    }}
                  >
                    <Text>{children}</Text>
                  </li>
                ),
              },
            })}
          {awards &&
            awards.map(awardData => (
              <Flex
                sx={{
                  alignItems: "center",
                  mt: theme => theme.spacing.vertical.sm,
                }}
                key={awardData.id}
              >
                {awardData.awardLogo && (
                  <img
                    src={awardData.awardLogo.file.url}
                    alt={awardData.awardLogo.title}
                  />
                )}
                {awardData.title && (
                  <Text
                    customStyle={{
                      fontWeight: "heading",
                      maxWidth: ["50%", "50%", "none"],
                      pl: 3,
                    }}
                  >
                    {awardData.title}
                  </Text>
                )}
              </Flex>
            ))}
        </Column>
        <Column
          customStyle={{
            mt: [
              theme => theme.spacing.vertical.md,
              theme => theme.spacing.vertical.md,
              0,
            ],
          }}
          size={[12, 12, 4, 3]}
        >
          <Row
            customStyle={{
              // minWidth: "130%",
              minWidth: "100%",
              "div:last-child": {
                "flex-basis": "60%",
                minWidth: "60%!important",
              },
            }}
          >
            {tableContent &&
              chunk(tableContent, Math.ceil(tableContent.length / 2)).map(
                (contentDataGroup, index) => (
                  <Column
                    key={index}
                    customStyle={{
                      overflowX: "visible",
                      minWidth: "40% !important",
                      "flex-basis": "40%",
                    }}
                  >
                    {contentDataGroup.map((contentData, index) =>
                      contentData.bodyText ? (
                        contentData.headingText ? (
                          <div
                            sx={{
                              mb: theme =>
                                contentDataGroup.length - 1 > index &&
                                contentDataGroup[index + 1].headingText
                                  ? theme.spacing.vertical.sm
                                  : contentData.page?"0":"10px",
                              ":last-child": { mb: 0 },
                            }}
                            key={index}
                          >
                            <Text
                              customStyle={{
                                fontWeight: "bold",
                                display: "inline",
                                // mt: '-30px !important',
                                // ...(contentData.pricingIcon
                                //   ? { whiteSpace: "nowrap" }
                                //   : {}),
                              }}
                            >
                              {contentData.headingText}
                              {contentData.pricingIcon && (
                                <InfoIconLink to="/" />
                              )}
                              {contentData.subHeadingText ? (
                                <Text
                                  customStyle={{
                                    fontWeight: "bold",
                                    fontStyle: "italic",
                                    marginTop: "10px",
                                    marginBottom: "4px"
                                  }}
                                >
                                  {contentData.subHeadingText}
                                </Text>
                              ) : contentData.headingText === "Cost Estimate"?(
                                <Text
                                  customStyle={{
                                    marginTop: contentData.page?"0":"10px"
                                  }}
                                  
                                ></Text>
                              ):null}
                              {typeof contentData.bodyText === "object" &&
                              contentData.bodyText.length > 0 ? (
                                contentData.bodyText.map(obj => {
                                  const [key, val] = obj.split(":")
                                  const value = val
                                    .replace("$", "")
                                    .replace("*", "")
                                  if (
                                    value &&
                                    key &&
                                    !isNaN(value) &&
                                    !obj.includes(
                                      "Design, Engineering and Permitting"
                                    )
                                  ) {
                                    return (
                                      <Text
                                        customStyle={{
                                          // WordWrap:"break-word"
                                          fontWeight: 500,
                                          mb: "5px",
                                        }}
                                      >
                                        {/* {numberWithCommas(obj)} */}
                                        {/* <span>{key}</span>:{" "} */}
                                        <span>{key}</span>
                                        <span sx={{ fontWeight: 400 }}>
                                          {(contentData.parseType && contentData.parseType === "model") ?  ": From "+numberWithCommas(val) : ": "+numberWithCommas(val)}
                                        </span>
                                      </Text>
                                    )
                                  } else if (
                                    key.includes(
                                      "Design, Engineering and Permitting"
                                    ) &&
                                    !isNaN(value)
                                  ) {
                                    const numWithCommas = numberWithCommas(obj)
                                    const split = numWithCommas.split("and")
                                    const newEle =
                                      split[0] + "<br/> and " + split[1]
                                    return (
                                      <Text
                                        customStyle={{
                                          // WordWrap:"break-word"
                                          fontWeight: 500,
                                          mb: "5px",
                                        }}
                                      >
                                        {split[0]} <br /> and Permitting:{" "}
                                        <span sx={{ fontWeight: 400 }}>
                                          {(contentData.parseType && contentData.parseType === "model") ?  " From "+numberWithCommas(val):  " "+numberWithCommas(val)}
                                        </span>
                                      </Text>
                                    )
                                  }
                                })
                              ) : (
                                <Text
                                // customStyle={{WordWrap:"break-word"}}
                                >
                                  {contentData.bodyText}
                                </Text>
                              )}
                            </Text>
                            {/* {contentData.pricingIcon && (
                                  <InfoIconLink to="/" />
                                )}
                              </Text>
                              <Text>{contentData.bodyText}</Text> */}
                          </div>
                        ) : typeof contentData.bodyText === "object" &&
                          contentData.bodyText.length > 0 ? (
                          contentData.bodyText.map(obj => (
                            <Text
                              customStyle={{
                                display: "inline",
                              }}
                            >
                              {numberWithCommas(obj)}
                            </Text>
                          ))
                        ) : typeof JSON.parse(contentData.bodyText) ===
                          "object" ? (
                          <RichText data={JSON.parse(contentData.bodyText)} />
                        ) : (
                          <Text
                            customStyle={{
                              display: "inline",
                            }}
                          >
                            {contentData.bodyText}
                          </Text>
                        )
                      ) : null
                    )}
                  </Column>
                )
              )}
          </Row>
          {locationUrl === "/models/koto-livinghome-1" ||
          locationUrl === "/models/koto-livinghome-2" ? (
            <CTA
              link={
                locationUrl === "/models/koto-livinghome-1"
                  ? "https://kotodesign.co.uk/koto-yksi-experience"
                  : "https://kotodesign.co.uk/koto-piha-experience"
              }
              type={"secondary"}
              linkType="external"
              customStyle={{
                paddingRight: "35px",
                paddingTop: "12px",
                paddingBottom: "12px",
                width: "fit-content",
                marginTop: "40px",
              }}
            >
              {"View in 3D"}
            </CTA>
          ) : null}
        </Column>
        <Column
          customStyle={{
            mt: [
              theme => theme.spacing.vertical.md,
              theme => theme.spacing.vertical.md,
              0,
            ],
            ml: [
              theme => theme.spacing.vertical.md,
              theme => theme.spacing.vertical.md,
              theme => theme.spacing.vertical.md,
              theme => theme.spacing.vertical.md,
            ],
          }}
          size={[12, 12, richText ? 2 : 3]}
        >
          {richText &&
            documentToReactComponents(richText, {
              renderNode: {
                [BLOCKS.HEADING_6]: (node, children) => (
                  <Text customStyle={{ fontWeight: "bold" }}>{children}</Text>
                ),
                [BLOCKS.PARAGRAPH]: (node, children) => (
                  <Text
                    customStyle={{
                      fontSize: 12,
                      fontWeight: "light",
                    }}
                  >
                    {children}
                  </Text>
                ),
                [BLOCKS.EMBEDDED_ASSET]: node => {
                  const { title, file } = node.data.target.fields

                  return (
                    <div>
                      <img
                        sx={{
                          display: "block",
                          // my: theme => theme.spacing.vertical.sm / 2,
                          marginBottom: theme => theme.spacing.vertical.sm / 2,
                          marginTop: "5px",
                        }}
                        src={file["en-US"].url}
                        alt={title["en-US"]}
                      />
                    </div>
                  )
                },
                [BLOCKS.UL_LIST]: (node, children) => (
                  <ul
                    sx={{
                      mb: 0,
                      "p+&": {
                        mt: -20,
                      },
                    }}
                  >
                    {children}
                  </ul>
                ),
                [BLOCKS.LIST_ITEM]: (node, children) => (
                  <li
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      lineHeight: 1,
                      mb: 0,
                      position: "relative",
                      ":last-child": { mb: 0 },
                      "::before": {
                        content: '"\\2022"',
                        fontSize: 1,
                        position: "absolute",
                        top: "5px",
                        left: "-12px",
                      },
                    }}
                  >
                    <Text>{children}</Text>
                  </li>
                ),
              },
            })}
          {inTheNews && (
            <div
              sx={{
                ...(richText && {
                  mt: theme => [
                    theme.spacing.vertical.md,
                    theme.spacing.vertical.md,
                    theme.spacing.vertical.sm,
                  ],
                }),
              }}
            >
              <Text
                customStyle={{
                  color: "tertiary",
                  fontSize: 11,
                  fontWeight: "heading",
                  mb: theme => theme.spacing.vertical.sm / 3,
                  textTransform: "uppercase",
                }}
              >
                In The News
              </Text>
              {inTheNews.map((newsData, index) => (
                <div
                  key={index}
                  sx={{
                    mb: theme => theme.spacing.vertical.sm / 2,
                    ":last-child": { mt: 0 },
                  }}
                >
                  <PageLink
                    customStyle={{ display: "block" }}
                    link={newsData.link || "/"}
                  >
                    {newsData.publicationTitle && !newsData.publicationLogo && (
                      <Text customStyle={{ fontWeight: "heading" }}>
                        {newsData.publicationTitle}
                      </Text>
                    )}
                    {newsData.publicationLogo && (
                      <img
                        sx={{ display: "block", maxWidth: 100 }}
                        src={newsData.publicationLogo.file.url}
                        alt={newsData.publicationLogo.title}
                      />
                    )}
                  </PageLink>
                </div>
              ))}
            </div>
          )}
        </Column>
      </Row>
    </Container>
  </div>
)

SpecificationsDetails.propTypes = {
  awards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      awardLogo: PropTypes.shape({
        file: PropTypes.shape({ url: PropTypes.string.isRequired }).isRequired,
        title: PropTypes.string,
      }),
    })
  ),
  description: PropTypes.object,
  inTheNews: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      publicationTitle: PropTypes.string,
      publicationLogo: PropTypes.shape({
        file: PropTypes.shape({ url: PropTypes.string.isRequired }).isRequired,
        title: PropTypes.string,
      }),
    })
  ),
  richText: PropTypes.object,
  tableContent: PropTypes.arrayOf(
    PropTypes.shape({
      bodyText: PropTypes.string,
      headingText: PropTypes.string,
    })
  ),
  locationUrl: PropTypes.string,
}

export default SpecificationsDetails
